import app from '@/init'
import router from '@/router'
import store from '@/store'
import HtProgress from 'nprogress'
import 'nprogress/nprogress.css'
import updatePageTitle from '@/utils/pageTitle'
import { fullScreenKey, sourceSystemKey, rolePermissionKey } from '@/config'
import {
  loadLanguageList,
  DEFAULT_LANGUAGE,
} from '@transsion/hotent-ui/packages/Language'

import { getRequestParam } from '@/utils/index.js'
import cop from './cop'
import './tina'

HtProgress.configure({
  easing: 'ease',
  speed: 500,
  trickleSpeed: 200,
  showSpinner: false,
})

async function mountApp() {
  await loadLanguageList()

  const locale = localStorage.getItem('lang') || DEFAULT_LANGUAGE

  if (app.$i18n) {
    app.$i18n.locale = locale
  }

  if (app.$validator) {
    app.$validator.localize(locale)
  }

  app.$mount('#app')

  app.$nextTick(() => {
    cop()
  })
}

router.onReady(async () => {
  router.beforeEach(async (to, from, next) => {
    HtProgress.start()

    let nextFlag = false
    if (from.query[fullScreenKey] && !to.query[fullScreenKey]) {
      to.query[fullScreenKey] = true

      nextFlag = true
    }

    if (from.query[rolePermissionKey] && !to.query[rolePermissionKey]) {
      to.query[rolePermissionKey] = from.query[rolePermissionKey]

      nextFlag = true
    }

    if (nextFlag) {
      next({ ...to })
      return
    }

    // 路由变化时刷新 token
    try {
      await store.dispatch('user/refreshTokens')
    } catch (e) {
      // token 刷新失败不阻断路由
      console.error(e)
    }

    const routes = store.getters['routes/routes']
    // 是否已经加载了routes
    if (routes && routes.length > 0) {
      next()
    } else {
      store.dispatch('user/toLoginUrl', window.location.href)
    }

    updatePageTitle(to.meta.title)
  })

  router.afterEach((to) => {
    // 是否有全屏显示页面的url参数
    if (
      to.query &&
      Object.prototype.hasOwnProperty.call(to.query, fullScreenKey)
    ) {
      if (to.query[fullScreenKey] === 'true') {
        // 有则更新到vuex中
        store.dispatch('routes/setFullScreenState', true)
      }
    }

    // 来源系统设置
    if (
      to.query &&
      Object.prototype.hasOwnProperty.call(to.query, sourceSystemKey)
    ) {
      if (to.query[sourceSystemKey]) {
        store.dispatch('routes/setSourceSystem', to.query[sourceSystemKey])
      }
    }

    HtProgress.done()
  })

  // 刷新页面，全屏显示未生效
  const fullScreenState = store.getters['routes/fullScreenState']
  if (
    !fullScreenState &&
    router.currentRoute?.query?.[fullScreenKey] === 'true'
  ) {
    store.dispatch('routes/setFullScreenState', true)
  }

  const sourceSystem = store.getters['routes/sourceSystem']
  if (!sourceSystem && router.currentRoute?.query?.[sourceSystemKey]) {
    store.dispatch(
      'routes/setSourceSystem',
      router.currentRoute?.query?.[sourceSystemKey]
    )
  }

  const rolePermission = store.getters['routes/rolePermission']
  if (!rolePermission && router.currentRoute?.query?.[rolePermissionKey]) {
    store.dispatch(
      'routes/setSourceSystem',
      router.currentRoute?.query?.[rolePermissionKey]
    )
  }

  const originalUrl = window.location.href

  try {
    await store.dispatch('user/ssoLogin', originalUrl)
    const url = await store.dispatch('user/cleanLoginPayload', originalUrl)

    if (url !== originalUrl) {
      window.history.replaceState(null, '', url)
    }
    // 嵌入到其它系统的页面不需要查询菜单
    const accessRoutes = await store.dispatch('routes/setAllRoutes')
    accessRoutes.forEach((route) => {
      router.addRoute(route)
    })

    await mountApp()
  } catch {
    store.dispatch('user/toLoginUrl')
  }
})

// 添加requestId
const requestParam = getRequestParam()
// 当有token，都重置requestId。若是待办中心内嵌，则会带入requestId；若是bpm自己登录跳转的页面，应该将requestId置为空
if (requestParam.token !== undefined)
  localStorage.setItem('requestId', requestParam.requestId)
